import React from "react";
import { fetchAuthSession } from "aws-amplify/auth";

export interface AuthorizedProps {
  children?: React.ReactNode;
}

interface AuthorizedState {
  authorized: boolean;
}

function getInitialState(): AuthorizedState {
  return {
    authorized: false,
  };
}

export default class Authorized extends React.Component<AuthorizedProps, AuthorizedState> {
  public mounted: boolean = false;
  public state = getInitialState();

  public async componentDidMount() {
    this.mounted = true;

    try {
      const session = await fetchAuthSession();

      if (!this.mounted) {
        return;
      }

      this.setState({
        authorized: !!session.tokens,
      });
    } catch {
      if (this.mounted) {
        this.setState({ authorized: false });
      }
    }
  }

  public componentWillUnmount(): void {
    this.mounted = false;
  }

  public render() {
    if (this.state.authorized) {
      return <>{this.props.children}</>;
    }

    return null;
  }
}
